import * as React from 'react'
import BottomNavLogoutButton from './Logout'
import BottomNavAdminSection from './AdminSection'
import BottomNavMyProfileButton from './MyProfile'
import BottomNavChatButton from './Chat'


export default function BottomNavSections() {

    return <div className="navTools">
        <BottomNavChatButton />
        <span className="navTools__divider" />
        <BottomNavAdminSection />
        <BottomNavMyProfileButton />
        <BottomNavLogoutButton />
    </div>
}
